export interface CodeKeyName {
  code?: number;
  key?: string;
  name?: string;
  color?: string;
}


export function createCodeKeyName(data?: Partial<CodeKeyName>): CodeKeyName {
  return {
    code: data?.code,
    key: data?.key,
    name: data?.name,
    color: data?.color,
  };
}
